function TopicModel({ id, title, }) {
  let obj = {};
  obj.id = id;
  obj.title = title;
  return obj;
}

export default TopicModel;